import { render, staticRenderFns } from "./Homework.vue?vue&type=template&id=26512cbd&"
import script from "./Homework.vue?vue&type=script&lang=js&"
export * from "./Homework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports